import type { AttachedDocument } from "../../../../../../../../../api/types/svTypes";

export const normalizeExtension = (ext: string) => (!ext ? "" : ext.startsWith(".") ? ext : `.${ext}`);

export const formatFileLabel = (item: AttachedDocument) => `${item.fileName}${normalizeExtension(item.fileExtension)}`;
